import React from "react";
import Spinwheel from "./Spinwheel";

const BuyReferralspinwheel = (props) => {
  return <Spinwheel {...props} initialTab="referrals" />;
};

export default BuyReferralspinwheel;